import { Path } from "@/navigations/routes";
import { ProjectApi } from "@/types";

const get = (key: string) => (data: any) => data[key];
const getData = () => get("data");

export const transformFullCategory = (
  data: any,
): ProjectApi.Blog.GetCategories.Category[] => {
  if (!data) return [];

  const firstTransform = getData()(data);
  const secondTransform = firstTransform.categories.edges.map(
    (edge: { node: ProjectApi.Blog.GetCategories.Category }) => edge.node,
  );

  return secondTransform;
};

const transformToBlog = ({
  id,
  date,
  title,
  tags,
  slug,
  excerpt: description,
  categories,
  content: body,
  author,
  ...post
}: any): ProjectApi.Blog.BlogData => {
  const authorText = `${author?.node?.firstName} ${author?.node?.lastName}`;
  const authorUrl = author?.node?.avatar?.url;
  return {
    id,
    title,
    slug,
    description: description || "",
    body: body || "",
    tags: tags?.nodes.map(get("name")) || [],
    date,
    // url: `/blog/dynamic?slug=${slug}`,
    url: `${Path.Blog}/${slug}`,
    imageUrl: post?.featuredImage?.node?.sourceUrl,
    imageSrcSet: post?.featuredImage?.node?.srcSet,
    altText: post?.featuredImage?.node?.altText,
    category: categories?.nodes?.map((category: any) => category.name) ?? [],
    author: authorText,
    authorUrl,
  };
};

export const transformFullBlog = (data: any): ProjectApi.Blog.BlogData[] => {
  if (!data) return [];

  const firstTransform = getData()(data);
  const secondTransform = firstTransform.posts.edges
    .map(get("node"))
    .map(transformToBlog);

  return secondTransform;
};

export const transformSingleBlog = (data: any) => {
  try {
    const firstTransform = getData()(data);
    const secondTransform = get("post")(firstTransform);
    const thirdTransform = transformToBlog(secondTransform);

    return thirdTransform;
  } catch (error) {
    return null;
  }
};
